import React from 'react'
import Header from './Header'
// import Menu from './Menu'

export interface NavsProps {
  showDefaultBgColor?: boolean,
}

export default function BasicLayout(props: NavsProps) {
  return (
    <>
      {/* <Menu {...props}/> */}
      <Header {...props}/>
    </>
  )
}
